"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.5606602,2.14644661 C10.6544284,2.2402148 10.7071068,2.36739176 10.7071068,2.5 L10.7071068,22 L8.70710678,22 L8.70705307,6.12085678 L5.41421356,9.41421356 L4,8 L9.85355339,2.14644661 C10.0488155,1.95118446 10.365398,1.95118446 10.5606602,2.14644661 Z M15.2928932,2 L15.2929469,17.8791432 L18.5857864,14.5857864 L20,16 L14.1464466,21.8535534 C13.9511845,22.0488155 13.634602,22.0488155 13.4393398,21.8535534 C13.3455716,21.7597852 13.2928932,21.6326082 13.2928932,21.5 L13.2928932,2 L15.2928932,2 Z"
  });
}.bind(void 0));

exports.default = _default;